import { FC } from 'react';
import { Dialog, DialogContent } from '@mui/material';

import { FormProvider } from '@carcareers/contexts';
import { AddPaymentForm } from '@carcareers/components';

interface AddPaymentModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const AddPaymentModal: FC<AddPaymentModalProps> = ({ open, onClose, onSuccess }) => {
  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent sx={{ p: 0 }}>
        <FormProvider>
          <AddPaymentForm onSuccess={handleSuccess} onClose={onClose} />
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};

export default AddPaymentModal;
